import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  overflow-x: auto;

  .table td {
    vertical-align: middle;
  }
`;
